import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ListButton } from '@app/core/components/list/list.component';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { UserGroupService } from '@app/services/user-group.service';

@Component({
    selector: 'tt-usergroup-table',
    templateUrl: './usergroup-table.component.html',
    styleUrls: ['./usergroup-table.component.css'],
    standalone: false
})
export class UsergroupTableComponent implements OnInit {
    public tables: Item[] = [];

    public itemState = '';

    public selectedId: string | number = '';

    public error = '';

    public readonly tablet: MediaQueryList;

    public readonly rowButtons: ListButton<Item>[] = [{ id: 'new-tab', icon: 'fas fa-window-restore', type: 'primary', onClick: ({ item }) => this.openInNewTab(item) }];

    constructor(
        private readonly groups: UserGroupService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator
    ) {
        this.navigator = useNavigatorFor(navigator, this); this.tablet = layout.getMediaQueries().tablet;
    }

    public async ngOnInit(): Promise<void> {
        try {
            await this.loadItems();
        } catch (error) {
            this.showError(error);
        }
    }

    private async loadItems(): Promise<void> {
        this.tables = await this.groups.getTables({
            argtype: String(this.navigator?.params['argtype'] ?? ''),
            argvalue: String(this.navigator?.params['argvalue'] ?? '')
        });

        for (const item of this.tables) {
            if (item.item_state && item.item_state > '') this.itemState = item.item_state;
        }
    }

    public async updateList(): Promise<void> {
        this.selectedId = '';

        try {
            await this.loadItems();
        } catch (error) {
            this.showError(error);
        }
    }

    public openInNewTab(item: Item): void {
        if (item.item_state) {
            this.navigator?.newTab({
                to: item.item_state,
                parms: item.item_parms
            });
        }
    }

    public openItem({ item, event }: { item: Item; event: MouseEvent }): void {
        if (this.tablet.matches && this.itemState === 'usergrouptableedit') {
            if (item.item_id !== '') this.selectedId = item.item_id;
            return;
        }

        if (item.item_state === 'customaction') {
            const action = item['item_action'];

            if (typeof action === 'function') action(item);
            return;
        }

        if (!item.item_state || item.item_path === '') return;

        const target = {
            to: item.item_state,
            parms: item.item_parms
        };

        if (event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }

    private showError(error: unknown): void {
        this.error = error instanceof Error ? error.message : String(error);
    }
}
